
angular
.module('swapick.permissions', ['permission', 'satellizer'])
.run(function (PermissionStore, RoleStore, $auth) {
  // Define anonymous permission
  
  
  PermissionStore
    .definePermission('logged', function (stateParams) {
      if ($auth.isAuthenticated()) {
        return true; 
      }
      return false;
    });

  



});


// WEBPACK FOOTER //
// ./src/config/permissions-config.js